var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useMemo, useState } from 'react';
import { Flex, Link, P, flatten } from '@tpr/core';
import { callAllEventHandlers } from '../../utils';
import SidebarMenu from './components/SidebarMenu';
import styles from './sidebar.module.scss';
export var isActive = function (settings) { return function (path, exact) {
    var _a = settings.matchPath, matchPath = _a === void 0 ? function () { } : _a, location = settings.location;
    return matchPath(location.pathname, { path: path, exact: exact });
}; };
export var useSectionsUpdater = function (sections, _a) {
    var history = _a.history, matchPath = _a.matchPath, location = _a.location;
    return sections.reduce(function (accumulator, section) {
        return __spreadArrays(accumulator, [
            __assign(__assign({}, section), { links: section.links.map(function (link) { return (__assign(__assign({}, link), { onClick: callAllEventHandlers(function (_a) {
                        var path = _a.path;
                        return history.push(path);
                    }, link.onClick), active: isActive({ matchPath: matchPath, location: location }), links: link.links &&
                        link.links.map(function (innerLink) { return (__assign(__assign({}, innerLink), { onClick: callAllEventHandlers(function (_a) {
                                var path = _a.path;
                                return history.push(path);
                            }, innerLink.onClick), active: isActive({ matchPath: matchPath, location: location }) })); }) })); }) }),
        ]);
    }, []);
};
export function useCalculateProgress(sections) {
    var totalSections = useMemo(function () { return flatten(sections.map(function (section) { return section.links; })); }, [sections]);
    var totalCompleted = useMemo(function () { return totalSections.filter(function (section) { return section.completed; }); }, [totalSections]);
    return [totalSections, totalCompleted];
}
export var Sidebar = function (_a) {
    var title = _a.title, titlePath = _a.titlePath, originalSections = _a.sections, _b = _a.maintenanceMode, maintenanceMode = _b === void 0 ? false : _b, matchPath = _a.matchPath, location = _a.location, history = _a.history, _c = _a.collapseNested, collapseNested = _c === void 0 ? false : _c, sectionCompleteLabel = _a.sectionCompleteLabel, sectionIncompleteLabel = _a.sectionIncompleteLabel;
    var routerProps = { matchPath: matchPath, location: location, history: history };
    var sections = useSectionsUpdater(originalSections, routerProps);
    var _d = useCalculateProgress(sections), totalSections = _d[0], totalCompleted = _d[1];
    var _e = useState(false), isHomePageActive = _e[0], setIsHomePageActive = _e[1];
    useEffect(function () {
        var match = matchPath(location.pathname, {
            path: titlePath,
            exact: true,
        });
        setIsHomePageActive(match);
    }, [location.pathname]);
    return (React.createElement("nav", { className: styles.sidebar },
        React.createElement(Flex, { cfg: { flexDirection: 'column', mt: 8 }, className: styles.sidebarMenu },
            React.createElement(Flex, { className: isHomePageActive ? styles.activeLink : '' },
                React.createElement(Link, { cfg: {
                        fontWeight: 3,
                        color: 'primary.2',
                        textAlign: 'left',
                        lineHeight: 6,
                        fontSize: 4,
                    }, onClick: function () { return history.push(titlePath); } }, title)),
            React.createElement(Flex, { cfg: { justifyContent: 'space-between', mt: 4, mb: 2 } },
                React.createElement(P, { cfg: {
                        color: 'neutral.8',
                        fontSize: 3,
                        fontWeight: 3,
                        lineHeight: 6,
                    }, className: styles.label }, "Section"),
                React.createElement(P, { cfg: {
                        color: 'neutral.8',
                        fontSize: 3,
                        fontWeight: 3,
                        lineHeight: 6,
                    }, className: styles.label },
                    "Progress ",
                    totalCompleted.length,
                    " / ",
                    totalSections.length))),
        React.createElement("ul", { className: styles.list }, sections
            .sort(function (a, b) { return a.order - b.order; })
            .map(function (item, key) { return (React.createElement("li", { key: key },
            React.createElement(SidebarMenu, { title: item.title, links: item.links, maintenanceMode: maintenanceMode, collapsed: collapseNested, sectionCompleteLabel: sectionCompleteLabel, sectionIncompleteLabel: sectionIncompleteLabel }))); }))));
};
//# sourceMappingURL=sidebar.js.map